module.exports = __webpack_public_path__ + "static/media/repair-n.2080d414.svg";